import "./locationDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface LocationDetailsViewComponentProps {
    locationInformation: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LocationDetailsViewComponent = (props: LocationDetailsViewComponentProps) => {
    const {locationInformation, onEditModeOpen, canEdit} = props;

    return (
        <div className={'location-details-view-component details-tab-data-content'}>
            {locationInformation && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Basic Details</div>
                    {canEdit &&
                        <div className={'edit-action-button'}>
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Facility Name"}> {locationInformation?.facilityDetails?.name ? CommonService.capitalizeFirstLetterOfEachWord(locationInformation?.facilityDetails?.name) : 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Location Name"}> {locationInformation?.name || 'N/A'} </DetailsDataKeyValueComponent>

                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Location Type"}> {locationInformation?.type || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Assigned Lab</div>
                    <DetailsDataKeyValueComponent
                        title={"Lab Name"}> {locationInformation?.labDetails?.name || 'N/A'} </DetailsDataKeyValueComponent>
                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Address Details</div>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Address Line 1"}> {locationInformation?.addressDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Address Line 2"}> {locationInformation?.addressDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"State"}> {locationInformation?.addressDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"ZIP Code"}> {locationInformation?.addressDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"City"}> {locationInformation?.addressDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                    <div className="horizontal-line"/>
                    <div className="view-and-edit-title">Emergency Contact Details</div>
                    {
                        locationInformation?.emergencyContactDetails?.length === 0 && <>
                            <div className="view-and-edit-title mrg-top-20">{`Contact 1`}</div>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Email ID"}> {'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Secondary Mobile Number"}> {'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Mobile Number"}> {'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Fax Number"}> {'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        </>
                    }
                    {
                        locationInformation?.emergencyContactDetails?.map((contactDetails: any, index: any) => {
                            return (
                                <div key={index}>
                                    <div className="view-and-edit-title mrg-top-20">{`Contact ${index + 1}`}</div>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <DetailsDataKeyValueComponent
                                                title={"Email ID"}> {contactDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(contactDetails?.secondaryMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} xl={6}>
                                            <DetailsDataKeyValueComponent
                                                title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(contactDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                title={"Fax Number"}> {contactDetails?.faxNumber || 'N/A'} </DetailsDataKeyValueComponent>
                                        </Grid>
                                    </Grid>
                                </div>
                            )
                        })
                    }
                </div>
            </>
            }
        </div>
    );

};

export default LocationDetailsViewComponent;
